const initState = {
    user:[]
}

const authReducer = (state = initState, action:any) =>{
    return state
} 

export default authReducer